export default "/wp-content/themes/allen-carr/public/dist/images/step-background-three-mob.png";